import type { SVGProps } from 'react'

/** Word/DOCX format mark — blue badge with W, no document chrome. */
export function FileFormatDocxIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <rect x="2" y="2" width="20" height="20" rx="4" fill="#2563EB" />
      <text
        x="12"
        y="16.5"
        textAnchor="middle"
        fill="#fff"
        fontSize="11"
        fontWeight="700"
        fontFamily="system-ui, -apple-system, sans-serif"
      >
        W
      </text>
    </svg>
  )
}
